'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeText = exports.frindlyName = exports.getCombinedKey = exports.getAgamaDate = exports.areArraysEquals = exports.secureTextNice = exports.secureText = exports.arrayMove = exports.AgamaUserTokenError = exports.AgamaUserError = exports.toPromise = exports.deepFreeze = exports.createTime = exports.getTimeNumber = exports.getUniqNow = exports.merge2ArrayByKey = exports.arrayUnique = exports.splitToPathParts = exports.getRandomString = exports.normalizePattern = exports.testText = exports.testTextExact = exports.groupBy = exports.selectMany = exports.firstOrNull = exports.single = exports.compactArray = exports.deArray = exports.toArray = exports.toDictionary = exports.distinct = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _freeze = require('babel-runtime/core-js/object/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getOwnPropertyNames = require('babel-runtime/core-js/object/get-own-property-names');

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

exports.toAgamaId = toAgamaId;
exports.fromAgamaId = fromAgamaId;

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var distinct = exports.distinct = function distinct(anArray, keyFunc) {
  var keys = [];
  var result = [];
  anArray.forEach(function (item) {
    var key = keyFunc(item);
    if (keys.indexOf(key) === -1) {
      keys.push(key);
      result.push(item);
    }
  });
  return result;
};

var toDictionary = exports.toDictionary = function toDictionary(anArray, keyFunc, valueFunc) {
  var obj = {};
  anArray.forEach(function (item) {
    var key = keyFunc(item);
    var value = valueFunc(item);
    obj[key] = value;
  });
  return obj;
};

var tabA = 'a b c d e f g h i j k l m n o p q r s t u v w y z 0 1 2 3 4 5 6 7 8 9'.split(' ');

// funkce převádí idčko obsahujici velká písmena na idčko složené pouze z malých písmen
// například:  Abc => abcxa; nebo aaAA => aaaaxcd
// délka ička je omezená polem tabA
function toAgamaId(id) {
  var result = id.toLowerCase() + 'x'; // poslední x je oddělovač
  for (var offset = 0; offset < id.length; offset++) {
    var ch = id.charAt(offset);
    // pokud je velké pismeno, pridáme za poslední x písmeno reprezentující pozici velkého písmena
    if (ch.toUpperCase() === ch) {
      result = result + tabA[offset];
    }
  }
  return result;
}
function fromAgamaId(agamaId) {
  var lastpos = 0;
  var pos = 0;
  var result = '';
  var offset = agamaId.lastIndexOf('x');
  var prefix = agamaId.substring(0, offset++);
  var sufix = agamaId.substring(offset);
  // console.log("sufix is "+sufix);
  for (var ii = 0; ii < sufix.length; ii++) {
    var ch = sufix.charAt(ii);
    pos = tabA.indexOf(ch);
    // console.log(pos);
    result += prefix.substring(lastpos, pos) + prefix[pos].toUpperCase();
    lastpos = ++pos;
  }
  result = result + prefix.substring(pos);
  return result;
}

// todo: to Utils
var toArray = exports.toArray = function toArray(objOrArray) {
  // console.log('volam toArray...' + objOrArray);
  return objOrArray instanceof Array ? objOrArray : [objOrArray];
};

// pokud je pole s jednim prvkem, vrati objekt, jinak ponechá pole. Pro prazdné pole vrací NULL.
var deArray = exports.deArray = function deArray(objOrArray) {
  return objOrArray instanceof Array ? objOrArray.length <= 1 ? objOrArray[0] : objOrArray : objOrArray; // eslint-disable-line no-nested-ternary
};

var compactArray = exports.compactArray = function compactArray(array) {
  /* eslint eqeqeq: [2, "smart"] */
  return array == null ? null : array.filter(function (ii) {
    return ii != null;
  });
};

var single = exports.single = function single(array) {
  if (!array || array.length !== 1) {
    throw new Error('Expected just single item');
  }
  return array[0];
};
var firstOrNull = exports.firstOrNull = function firstOrNull(array, predicate) {
  var result = null;
  var exists = array.some(function (x, i) {
    var match = predicate(x, i);
    if (match) result = x;
    return match;
  });
  return exists ? result : null;
};

// Array.prototype.selectMany = Array.prototype.selectMany || (projector => { // eslint-disable-line no-extend-native
//   return this.map(projector).reduce( (x, y) => x.concat(y), []);
// });

// https://gist.github.com/aaronpowell/4108776
// usage: console.log([[1,2,3], [4,5,6]].selectMany(function (x) { return x; })); //[1,2,3,4,5,6]
var selectMany = exports.selectMany = function selectMany(array, projector) {
  return array.map(projector).reduce(function (xx, yy) {
    return xx.concat(yy);
  }, []);
};

var groupBy = exports.groupBy = function groupBy(pole, fn) {
  var res = {};
  pole.forEach(function (item) {
    var key = fn(item);
    var val = res[key];
    if (!val) val = res[key] = [];
    val.push(item);
  });
  return res;
};

// testuje zda string odpovídá masce, například:
// testTextExact('lokomotiva', 'loko*tiv*') => true
var testTextExact = exports.testTextExact = function testTextExact(textToTest, simplePattern) {
  // a = new RegExp('aaaAa.*$','i')
  var regPattern = simplePattern.replace(/\*/g, '.*') + '$';
  // console.log(regPattern);
  var regex = new RegExp(regPattern, 'i');
  var res = regex.test(textToTest);
  return res;
};

// testuje zda vyhoví alespoň jedno slovo, například:
// testText('karel gott', 'gott lá*ko') => true (protože gott vyhověl)
var testText = exports.testText = function testText(textToTest, simplePattern) {
  var withOther = function withOther(word) {
    return ('*' + word + '*').replace(/\*+/g, '*');
  };
  var words = simplePattern.split(' ');
  var textWordsLength = textToTest.split(' ').length;
  var vyhovujicichSlovPatternu = words.map(function (patternWord) {
    return 1 * testTextExact(textToTest, withOther(patternWord));
  }).reduce(function (xx, yy) {
    return xx + yy;
  }, 0);
  var priority = vyhovujicichSlovPatternu - (textWordsLength - vyhovujicichSlovPatternu) / 10;
  return { priority: Math.max(priority, 0) };
};

// https://jsfiddle.net/gqngswgq/3/
var normalizePattern = exports.normalizePattern = function normalizePattern(txt, pridatPoslHvezdicku /* default je true */) {
  var searchText = txt.replace(/\*+/g, '*') // nahrazení více než dvou *
  .replace(/\ \*$/g, '') // nahrazení koncových * s mezerou před
  .replace(/^\* /g, '') // nahrazení koncových * s mezerou před
  .replace(/\ \*\ /g, '') // nahrazení samotných hvězdiček
  .replace(/\*+/g, '*') // opet hvezdičky (po nahrazení * * *)
  .replace(/\ \*$/g, '') // nahrazení koncových * s mezerou před
  .replace(/\ +/g, ' ') // více mezer
  .replace(/[.+^${}()|\>\<\@\#\%\/\_[\]\+\=\^\\]/g, '') // divné znaky
  .trim();
  // .replace(/\ /g, '-');
  if (pridatPoslHvezdicku == null || pridatPoslHvezdicku === true) {
    if (!txt.endsWith(' ') && !searchText.endsWith('*')) searchText += '*';
  }
  var count = 0;
  searchText = searchText.split('').filter(function (xx) {
    var jeHvezdicka = xx === '*';
    if (jeHvezdicka) count++;
    return !jeHvezdicka || count < 3;
  }).join('');
  return searchText;
};

// Create a nice client unique enough id.
// https://github.com/google/closure-library/blob/2012c5372fdb02ce9531cf4b2561b05e3ce2ab39/closure/goog/string/string.js#L1183
var getRandomString = exports.getRandomString = function getRandomString() {
  var xx = 2147483648;
  return Math.floor(Math.random() * xx).toString(36) + Math.abs(Math.floor(Math.random() * xx) ^ Date.now()).toString(36);
};

var splitToPathParts = exports.splitToPathParts = function splitToPathParts(str) {
  if (str.length > 6) return str.substring(0, 2) + '/' + str.substring(2, 4) + '/' + str.substring(4, 6) + '/' + str.substring(6);
  if (str.length > 4) return str.substring(0, 2) + '/' + str.substring(2, 4) + '/' + str.substring(4);
  if (str.length > 2) return str.substring(0, 2) + '/' + str.substring(2);
  return str;
};

/**
 * Něco jako distinct
 * @param {array}
 *
 */
var arrayUnique = exports.arrayUnique = function arrayUnique(array) {
  var a = array.concat(); //eslint-disable-line
  for (var i = 0; i < a.length; ++i) {
    //eslint-disable-line
    for (var j = i + 1; j < a.length; ++j) {
      //eslint-disable-line
      if (a[i] === a[j]) //eslint-disable-line
        a.splice(j--, 1); //eslint-disable-line
    }
  }
  return a; //eslint-disable-line
};

//zmerguje dve pole, unikatnost rozhoduje na zaklade klice, prioritne ve vysledne sade jsou prvky z prvni kolekce
var merge2ArrayByKey = exports.merge2ArrayByKey = function merge2ArrayByKey(array1, array2, keySelector) {
  var sortComparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var existingKeys = array1.map(keySelector);
  var secondPart = array2.filter(function (x) {
    var newKey = keySelector(x);
    return existingKeys.indexOf(newKey) === -1;
  });
  var res = array1.concat(secondPart);
  if (sortComparator) res.sort(sortComparator);
  return res;
};

var lastNow = 0;
/** Vraci číslo, které se neustále zvyšuje a je založeno na aktuálním čase, není thread safe!! */
var getUniqNow = exports.getUniqNow = function getUniqNow() {
  var now = new Date() * 1;
  if (now <= lastNow) {
    now = lastNow + 1;
  }
  lastNow = now;
  return now;
};

var getTimeNumber = exports.getTimeNumber = function getTimeNumber(timestamp) {
  var now = timestamp * 1;
  return now;
};
var createTime = exports.createTime = function createTime(timestampNumber) {
  var cas = new Date(timestampNumber);
  return cas;
};

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
var deepFreeze = exports.deepFreeze = function deepFreeze(obj) {
  // Retrieve the property names defined on obj
  var propNames = (0, _getOwnPropertyNames2.default)(obj);
  // Freeze properties before freezing self
  propNames.forEach(function (name) {
    var prop = obj[name];
    // Freeze prop if it is an object
    if ((typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop)) == 'object' && prop !== null) deepFreeze(prop);
  });
  // Freeze self (no-op if already frozen)
  return (0, _freeze2.default)(obj);
};

var toPromise = exports.toPromise = function toPromise(obj) {
  if (typeof obj === 'function') {
    //console.log('balim funkci na promise '+obj);
    var wrap = function wrap() {
      try {
        var args = arguments;
        var result = obj.apply(null, args);
        return toPromise(result);
      } catch (error) {
        return _bluebird2.default.reject(error);
      }
    };
    //console.log('Promise vytvorena');
    return wrap;
  }
  return obj && obj.then ? obj : _bluebird2.default.resolve(obj);
};

var AgamaUserError = exports.AgamaUserError = function (_Error) {
  (0, _inherits3.default)(AgamaUserError, _Error);

  function AgamaUserError(message, optData) {
    (0, _classCallCheck3.default)(this, AgamaUserError);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AgamaUserError.__proto__ || (0, _getPrototypeOf2.default)(AgamaUserError)).call(this, message));

    _this.message = message;
    _this.status = 406;
    _this.name = 'AgamaUserError';
    if (optData) {
      _this.data = optData;
    }
    return _this;
  }

  return AgamaUserError;
}(Error);
// nastava, pokud server odmitne duverovat klientovi - napr pri zmene IP adresy (napr, uzivatel zmenil pripojeni = nejde nutne o chybu)


var AgamaUserTokenError = exports.AgamaUserTokenError = function (_Error2) {
  (0, _inherits3.default)(AgamaUserTokenError, _Error2);

  function AgamaUserTokenError(message, optData) {
    (0, _classCallCheck3.default)(this, AgamaUserTokenError);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (AgamaUserTokenError.__proto__ || (0, _getPrototypeOf2.default)(AgamaUserTokenError)).call(this, message));

    _this2.message = message || 'please, revive your credentials...';
    _this2.status = 403;
    _this2.name = 'AgamaUserTokenError';
    if (optData) {
      _this2.data = optData;
    }
    return _this2;
  }

  return AgamaUserTokenError;
}(Error);

// http://stackoverflow.com/questions/5306680/move-an-array-element-from-one-array-position-to-another
// přehodí pořadí, vraci nové immuatable pole ;


var arrayMove = exports.arrayMove = function arrayMove(origArray, oldIndex, newIndex) {
  var array = [].concat((0, _toConsumableArray3.default)(origArray));
  while (oldIndex < 0) {
    oldIndex += array.length; // eslint-disable-line 
  }
  while (newIndex < 0) {
    newIndex += array.length; // eslint-disable-line 
  }
  while (newIndex >= array.length) {
    newIndex = 0; // eslint-disable-line 
  }
  // if (newIndex >= array.length) {
  //   let kk = newIndex - array.length;
  //   while ((kk--) + 1) {
  //     array.push(undefined);
  //   }
  // }
  array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
  (0, _freeze2.default)(array);
  return array;
};

var secureText = exports.secureText = function secureText(txt) {
  if (txt == null) return '';
  return txt.replace(/\?/g, '').replace(/\#/g, '').replace(/\%/g, '').replace(/\//g, '').replace(/\\/g, '').replace(/\@/g, '').replace(/\</g, '').replace(/\>/g, '').substring(0, 30);
};
var secureTextNice = exports.secureTextNice = function secureTextNice(txt) {
  var nice = secureText(txt);
  return nice.substring(0, 1).toUpperCase() + nice.substring(1);
};

var areArraysEquals = exports.areArraysEquals = function areArraysEquals(array1, array2) {
  return array1.length === array2.length && array1.every(function (element, index) {
    return element === array2[index];
  });
};

var getAgamaDate = exports.getAgamaDate = function getAgamaDate(aa /* datum */) {
  // vraci string 2016-01-31
  return ('0' + aa.getYear()).slice(-2) + '-' + ('0' + (1 + aa.getMonth())).slice(-2) + '-' + ('0' + aa.getDate()).slice(-2);
};

var getCombinedKey = exports.getCombinedKey = function getCombinedKey(key1, optKey2) {
  if (optKey2) return key1 + '|' + optKey2;
  return key1;
};

// todo: fce je pouzita také v TreeItem a MiniTools => DRY => sdilet odsud
var frindlyName = exports.frindlyName = function frindlyName(name) {
  return name.replace(/\?/g, '');
};

var normalizeText = exports.normalizeText = function normalizeText(text) {
  var t = text.replace(/(\r)/gm, '');
  return t;
};

// Array.prototype.move = function (old_index, new_index) {
//     if (new_index >= this.length) {
//         var k = new_index - this.length;
//         while ((k--) + 1) {
//             this.push(undefined);
//         }
//     }
//     this.splice(new_index, 0, this.splice(old_index, 1)[0]);
//     return this; // for testing purposes
// };

// export const matchText = (textToSplit, simplePattern) => {
//   const txt = simplePattern
//   const regPattern = simplePattern.replace(/\*/g, '.*');

//   textToSplit.match(regPattern)
// };

// Array.prototype.groupBy = function(hash){
//   var _hash = hash ? hash : function(o){return o;};

//   var _map = {};
//   var put = function(map, key, value){
//     if (!map[_hash(key)]) {
//         map[_hash(key)] = {};
//         map[_hash(key)].group = [];
//         map[_hash(key)].key = key;

//     }
//     map[_hash(key)].group.push(value);
//   }

//   this.map(function(obj){
//     put(_map, obj, obj);
//   });

//   return Object.keys(_map).map(function(key){
//     return {key: _map[key].key, group: _map[key].group};
//   });
// }


//////////////////
// WEBPACK FOOTER
// ./api/actions/Db/utils.js
// module id = 61
// module chunks = 0